import Axios from 'axios';
import { useEffect } from 'react';

// components
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { PrivateRoute, AuthProvider } from './auth';
import { View } from 'components/lib';
import { NotFound } from 'views/404';
import Settings from 'settings';
import store from '../store/store';
import { fetchMyPermissions } from '../store/slices/rbacSlice'

// tailwind css
import '../css/output.css';

const routes = [

  ...require('routes').default,
  ...require('routes/setup').default,

]

export default function App(props) {

  const user = JSON.parse(localStorage.getItem('user'));
  Axios.defaults.baseURL = Settings[process.env.REACT_APP_YOSUITE_ENV_MODE].server_url || 'http://localhost:5501';

  if (user?.token) {
    Axios.defaults.headers.common['Authorization'] = 'Bearer ' + user.token;
    
    // Fetch RBAC permissions on app load
    // store.dispatch(fetchMyPermissions());
  }

  // Only fetch permissions once on mount, not on every render
  // signin() handles fetching after login, this covers page refresh
  useEffect(() => {
    if (user?.token) {
      const rbacState = store.getState().rbac;
      // Only fetch if not already loaded (e.g. page refresh)
      if (!rbacState.myPermissions && !rbacState.loading) {
        store.dispatch(fetchMyPermissions());
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // render the routes
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {routes.map(route => {
            return (
              <Route
                key={route.path}
                path={route.path}
                element={
                  route.accountType ?
                    <PrivateRoute accountType={route.accountType}>
                      <View display={route.view} layout={route.layout} title={route.title} />
                    </PrivateRoute> :
                    <View display={route.view} layout={route.layout} title={route.title} />
                }
              />
            )
          })}
          <Route path='*' element={<View display={NotFound} layout='home' title='404 Not Found' />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
